import { useContext } from "react";
import { Box, Button } from '@mui/material';
import { Sync as SyncIcon } from '@mui/icons-material';
import { SalesBranchReport } from "../../../../global/API";
import { ToolContext } from "../../../../../../core/context/ToolContext";

import { FeatureIdState } from "../../../../toolUsage/global/GlobalFcn";
import { CreateFeatureLogs } from "../../../../global/API";
import moment from "moment";

export const Generate = () => {
    const { tool_state, report_state, global_component_state } = useContext(ToolContext);
    const { __SESSION } = tool_state;
    const { form, generateForm, salesBranchData, salesBranchList } = report_state;
    const { snackBarLoader } = global_component_state;
    const tool_id = process.env.REACT_APP_TID_BIZ;

    const SendFeatureLogs = async () => {
        const body = {
            aid: __SESSION.data.ainfo.aid,
            path: `${FeatureIdState("reports")}->1`,
            feature_id: 1,
            feature_name: "branch-sales-report",
            tid: tool_id,
            company_id: __SESSION.data.uaccess[0].company_id,
            action: 2,
        };
        await CreateFeatureLogs(body);
    };

    const FormatData = (rows) => {
        const groupedData = rows.reduce((acc, item) => {
            const {
                date,
                id,
                total_sales,
                created_at,
                company_branch_id,
                actual_sales,
                variance,
                remarks,
            } = item;

            const key = `${id}-${date}-${company_branch_id}`;

            if (!acc[key]) {
                acc[key] = {
                    ...item,
                    remarks: remarks === null ? "" : remarks,
                    variance: variance === null ? 0 : variance,
                    actual_sales: actual_sales === null ? 0 : actual_sales,
                    total_sales: parseFloat(total_sales) || 0,
                    date: id === null ? moment(created_at).format("YYYY-MM-DD") : date,
                };
            } else {
                acc[key].total_sales += parseFloat(total_sales) || 0;
            }

            return acc;
        }, {});

        const result = Object.values(groupedData);
        salesBranchData.set(rows);
        salesBranchList.set(result);
    };

    const handleGenerate = async () => {
        if (
            form.data.to === "" ||
            form.data.from === "" ||
            form.data.to < form.data.from
        ) {
            snackBarLoader.set({
                ...snackBarLoader.data,
                snackbar: true,
                msg: "Invalid Date!",
                type: "error",
            });
            return;
        }

        generateForm.set((prev) => ({
            ...prev,
            infiniteLoad: true,
            offset: 0,
        }));

        salesBranchData.set([]);
        salesBranchList.set([]);

        try {
            const limit = generateForm.data.limit;
            let offset = 0;
            let allRows = [];
            let shouldContinue = true;

            while (shouldContinue) {
                const qsp = {
                    branch_id: form.data.branch_id,
                    company_id: __SESSION.data.uaccess[0].company_id,
                    user_id: form.data.user_id,
                    from: form.data.from,
                    to: form.data.to,
                    limit,
                    offset,
                };

                const res = await SalesBranchReport(qsp);

                if (!res || !Array.isArray(res)) {
                    shouldContinue = false;
                    break;
                }

                if (res.length === 0) {
                    shouldContinue = false;
                    break;
                }

                allRows = [...allRows, ...res];
                offset += res.length;

                generateForm.set((prev) => ({
                    ...prev,
                    offset,
                }));

                if (res.length < limit) {
                    shouldContinue = false;
                }
            }

            FormatData(allRows);
            await SendFeatureLogs();
        } catch (error) {
            console.error(error);
            snackBarLoader.set({
                ...snackBarLoader.data,
                snackbar: true,
                msg: "Failed to generate report.",
                type: "error",
            });
        } finally {
            generateForm.set((prev) => ({
                ...prev,
                infiniteLoad: false,
                offset: 0,
            }));
        }
    };

    return (
        <Box
            minHeight="55px"
            display="flex"
            flexDirection="column"
            justifyContent="flex-end"
            alignItems="center"
            gap={2}
            width="100%"
        >
            <Box
                id="walkthrough-branch-sales-report-step-5"
                onClick={handleGenerate}
                component={Button}
                disableFocusRipple={true}
                minHeight="50px"
                minWidth="130px"
                borderRadius={3}
                display="flex"
                alignItems="center"
                justifyContent="center"
                bgcolor="primary.main"
                color="#fff"
                sx={{
                    gap: 2,
                    width: "100%",
                    border: "2px solid #EBEBEB",
                    ':hover': { bgcolor: 'primary.main', color: '#FFFFFF' }
                }}
            >
                <SyncIcon />
                <Box fontSize={16} fontWeight={400} lineHeight="19px">
                    Generate
                </Box>
            </Box>
        </Box>
    )
}